import { FC } from "react";

import { StatisticRecord } from "@graphql/types/graphql";

import { StructuredText } from "components/sections/RichtextSection/StructuredText";
import s from "./Statistic.module.scss";

interface Props {
  data: StatisticRecord;
}

export const Statistic: FC<Props> = ({ data: { pretitle, title, text } }) => (
  <>
    <div className={s.Pretitle}>{pretitle}</div>
    <div className={s.Title}>{title}</div>
    <div className="prose">
      <StructuredText structuredText={text as any} />
    </div>
  </>
);
